// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  host: "http://localhost:8080/",
  name: 'DEV',
  version: '2.0.1-GCP',
  hsbcNetUrl: "http://a356p7l585qa74v.in.hsbc:4200/assets/hsbc-net.html",
  useCurrentHost: true
  /* nodeName: "HSS",
  nodeType: "GHSS", 
  version: require('../../package.json').version,*/
};
//http://ec2-13-250-75-251.ap-southeast-1.compute.amazonaws.com:8080/, http://a356p7l585qa74v.in.hsbc:8080/
//Nitesh: http://ec2-13-228-185-241.ap-southeast-1.compute.amazonaws.com:8080/, http://a356a7l64cr5fr7.in.hsbc:8080/
//Suvit: http://ec2-13-228-250-145.ap-southeast-1.compute.amazonaws.com:8080/, http://A356F7L57WQA7JY.in.hsbc:8080/
//Shabbeer: http://A356M7L63K95FQ4.in.hsbc:8080/
//UAT: "https://digital-vault-uat-client.systems.hk.hsbc:8443/"
//SIT: "https://digital-vault-sit-client.systems.hk.hsbc:8443/"